'use client';

import React from 'react';
import { useVariantSelection } from './VariantSelectionContext';
import { memo } from 'react';
import styles from './MobileStickyBuyButton.module.css';

const MobileStickyBuyButton: React.FC = memo(() => {
  const { handleBuyClick } = useVariantSelection();

  return (
    <button
      className={styles.stickyBuyButton}
      onClick={handleBuyClick}
      aria-label={`Buy Diesel x Ultrahuman ring`}
    >
      Buy Now
    </button>
  );
});

MobileStickyBuyButton.displayName = 'MobileStickyBuyButton';

export default MobileStickyBuyButton;
